import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewPackageSourceTextPipe } from './review-package-source-text.pipe';

@NgModule({
  declarations: [ReviewPackageSourceTextPipe],
  imports: [CommonModule],
  exports: [ReviewPackageSourceTextPipe]
})
export class ReviewPackageSourceTextModule { }
